import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

export default function Services() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setItems(r.data)); }, []);

  return (
    <div data-testid="page-services" className="bg-[#F9F8F6]">
      <section className="container-editorial pt-16 md:pt-24 pb-12">
        <div className="text-[10px] uppercase tracking-[0.32em] text-[#7A736C] mb-6">Services</div>
        <h1 className="font-serif text-5xl md:text-7xl lg:text-[80px] tracking-tight leading-[1] max-w-4xl">One studio. One team. From single-room briefs to full turnkey homes.</h1>
        <p className="mt-8 max-w-2xl text-[#4A4642] leading-relaxed">Hiraya takes on residential and commercial interior projects across India. Each engagement is shaped around your brief — full mandate, room-level design, or consultation-only.</p>
      </section>

      <section className="container-editorial pb-24 md:pb-32">
        <div className="border-t border-[#D5D0C8]">
          {items.map((s, i) => (
            <Link key={s.id} to={`/services/${s.slug}`} data-testid={`service-row-${i}`} className="group grid grid-cols-12 gap-6 py-10 md:py-14 border-b border-[#D5D0C8] items-center hover:bg-[#F2EFE9] transition-colors">
              <div className="col-span-2 md:col-span-1 text-xs text-[#7A736C]">0{i + 1}</div>
              <div className="col-span-10 md:col-span-4">
                <div className="font-serif text-3xl md:text-4xl tracking-tight group-hover:text-[#A85C42] transition-colors">{s.title}</div>
              </div>
              <div className="col-span-12 md:col-span-5 text-[#4A4642] leading-relaxed">{s.short_description}</div>
              <div className="col-span-12 md:col-span-2 flex md:justify-end">
                <ArrowUpRight size={22} strokeWidth={1.25} className="opacity-40 group-hover:opacity-100 group-hover:text-[#A85C42] transition" />
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="container-editorial pb-24 md:pb-32">
        <div className="bg-[#2B2927] text-[#F9F8F6] p-12 md:p-16 rounded-sm">
          <h2 className="font-serif text-3xl md:text-5xl tracking-tight max-w-2xl">Not sure which service you need? A consultation is the honest starting point.</h2>
          <Link to="/consultation" className="inline-flex mt-8 px-8 py-4 bg-[#F9F8F6] text-[#2B2927] text-xs uppercase tracking-[0.24em] rounded-sm hover:bg-[#A85C42] hover:text-white transition-colors">Book a consultation</Link>
        </div>
      </section>
    </div>
  );
}
